import { connect } from "react-redux";

import { 
  fetchDiscoveryAssetViewsGraphReport, fetchDiscoveryAssetsGraphReport,
  fetchDiscoveryTeamMembersGraphReport, fetchDiscoveryShareGraphReport, 
  fetchDiscoveryContentMatrix, fetchDiscoveryCollectionActivityGraphReport, 
  fetchDiscoveryPopularAssets,
  fetchDiscoveryTopUsers, fetchDiscoveryTopUserGroups,
  fetchDiscoverySearchQueries, fetchDiscoverySearchTags,
  fetchDiscoveryCollections, fetchDiscoveryCollectionsShared,
  fetchDiscoveryTopSharers, fetchDiscoveryAssetsShared,
  intializeDownloadReport
} from "../../../redux/actions/reports.jsx";

import { trackAdoptionMetricsForReportsToggledViewEvent } from "src/legacy/redux/actions/adoption.jsx";

import DiscoveryReportView from "./view.jsx";

const mapStateToProps = (state, ownProps) => {
  return {
    discoveryMatrix: state.legacyRootReducer.reports.discovery.contentMatrix.item,
    filters: state.legacyRootReducer.reports.selection.filters || [],
    download: state.legacyRootReducer.reports.download
  };
};

const mapDispatchToProps = dispatch => {
  return {

    fetchDiscoveryContentMatrix: (filter) => {
      return dispatch(fetchDiscoveryContentMatrix(filter));
    },

    fetchDiscoveryAssetViewsGraphReport: (filter) => {
      return dispatch(fetchDiscoveryAssetViewsGraphReport(filter));
    },

    fetchDiscoveryAssetsGraphReport: (filter) => {
      return dispatch(fetchDiscoveryAssetsGraphReport(filter));
    },

    fetchDiscoveryShareGraphReport: (filter) => {
      return dispatch(fetchDiscoveryShareGraphReport(filter));
    },

    fetchDiscoveryCollectionActivityGraphReport: (filter) => {
      return dispatch(fetchDiscoveryCollectionActivityGraphReport(filter));
    },

    fetchDiscoveryPopularAssets: (filter, page, limit) => {
      return dispatch(fetchDiscoveryPopularAssets(filter, page, limit));
    },

    fetchDiscoveryTopUsers: (filter, page, limit) => {
      return dispatch(fetchDiscoveryTopUsers(filter, page, limit));
    },

    fetchDiscoveryTopSharers: (filter, page, limit) => {
      return dispatch(fetchDiscoveryTopSharers(filter, page, limit));
    },

    fetchDiscoveryTopUserGroups: (filter, page, limit) => {
      return dispatch(fetchDiscoveryTopUserGroups(filter, page, limit));
    },

    fetchDiscoverySearchQueries: (filter, page, limit) => {
      return dispatch(fetchDiscoverySearchQueries(filter, page, limit));
    },

    fetchDiscoverySearchTags: (filter, page, limit) => {
      return dispatch(fetchDiscoverySearchTags(filter, page, limit));
    },

    fetchDiscoveryCollections: (filter, page, limit) => {
      return dispatch(fetchDiscoveryCollections(filter, page, limit));
    },

    fetchDiscoveryCollectionsShared: (filter, page, limit) => {
      return dispatch(fetchDiscoveryCollectionsShared(filter, page, limit));
    },

    fetchDiscoveryAssetsShared : (filter, page, limit) => {
      return dispatch(fetchDiscoveryAssetsShared(filter, page, limit));
    },

    downloadReport: (id, filter, page, limit) => {
      return dispatch(intializeDownloadReport(id, filter, page, limit));
    },
    
    trackAdoptionMetricsForReportsToggledViewEvent: (tabType) => {
      return dispatch(trackAdoptionMetricsForReportsToggledViewEvent(tabType))
    }
  };
};

const DiscoveryReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscoveryReportView);

export default DiscoveryReport;